import React from "react";
import type {
  DocumentValidation,
  ProcDocument,
} from "../../../../application/domain/proc-management";
import { DocumentInput } from "./document-input";
import { ListInput } from "./list-input";
import type { FileInputProps, InputProps, PathProps } from "./types";

const notices = [
  "手続きを行うに当たって、ユーザーが記入する必要がある申請書などの様式を列挙し、ファイルをアップロードします。",
  "例: 市税証明交付申請書",
];

type Props = InputProps &
  PathProps &
  FileInputProps & {
    label: string;
    value: ProcDocument[];
    validationErrors: DocumentValidation[];
  };

export const ProcedureDocumentsListInput: React.FC<Props> = ({
  label,
  value,
  onChange,
  onFileAttached,
  getFileUploading,
  disabled = false,
  basePath,
  shouldDisplayError = false,
  validationErrors,
}) => {
  return (
    <ListInput
      label={label}
      required
      component={DocumentInput}
      componentProps={value.map((doc, i) => ({
        ...doc,
        onChange,
        onFileAttached,
        getFileUploading,
        shouldDisplayError,
        validationErrors: validationErrors[i],
      }))}
      basePath={basePath}
      onPush={() => {
        onChange(basePath, [
          ...value,
          {
            name: "",
            fileName: "",
          },
        ]);
      }}
      onRemove={(i) => {
        onChange(basePath, [...value.slice(0, i), ...value.slice(i + 1)]);
      }}
      disabled={disabled}
      notices={notices}
    />
  );
};
